/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_AgentInputs */

const en_fw_bm_col_agent = /** @type {(inputs: Fw_Bm_Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

const id_fw_bm_col_agent = /** @type {(inputs: Fw_Bm_Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen`)
};

/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Fw_Bm_Col_AgentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_agent = /** @type {((inputs?: Fw_Bm_Col_AgentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_AgentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_agent(inputs)
	return en_fw_bm_col_agent(inputs)
});